import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualCallFeedbackReport extends React.Component {
  constructor(props) {
    super(props);

    // Get feedback options from local storage
    const feedbackOptions = reactLocalStorage.getObject(Constants.Model).call.fields.feedback.options;
    this.state = {
      feedbackData: [],
      feedbackOptions,
      inApiCall: true,
    };
  }

  componentDidMount() {
    // Fetch call feedback data
    IndividualSalesReportAPI.getIndividualCallFeedback(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    this.setState({ feedbackData: data, inApiCall: false });
  };

  handleFail = () => {
    this.setState({ inApiCall: false });
  };

  render() {
    const { feedbackData, feedbackOptions, inApiCall } = this.state;

    // Create a dictionary to map feedback values to sums
    const feedbackSums = feedbackOptions.reduce((acc, option) => {
      acc[option.value] = 0;
      return acc;
    }, {});

    // Populate the feedback sums with the actual data
    feedbackData.forEach(item => {
      if (feedbackSums.hasOwnProperty(item.feedback)) {
        feedbackSums[item.feedback] = item.sum;
      }
    });
    const totalSum = Object.values(feedbackSums).filter(Boolean).reduce((total, value) => total + value, 0);


    return (
      <ApiUiController inApiCall={inApiCall}>
        <div>
          <h2>Call Feedback Report</h2>
          <hr />
        <div className="row mt-3 p-2">
          <Table striped bordered hover className="col-md-6">
            <thead>
              <tr>
                <th>Feedback</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {feedbackOptions.map(({ label, value }) => (
                <tr key={value}>
                  <td>{label}</td>
                  <td>{feedbackSums[value]}</td>
                </tr>
              ))}
              <tr>
                <td><strong>Total</strong></td>
                <td><strong>{totalSum}</strong></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
              {/* Pass only progressSums and progressOptions to ChartComponent */}
              <ChartComponent progressSums={feedbackSums} progressOptions={feedbackOptions} type={"pie"}/>
          </div>
        </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(IndividualCallFeedbackReport);
